var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"wrapper"},[_c('publicNav'),_c('router-view',{staticClass:"wrapper"})],1),_c('publicFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }